/** Canvas filter fallback: soften alpha only, never the source photograph. */
export function blurMask(pixels: ImageData, radius: number) {
  const { width, height, data } = pixels,
    r = Math.max(1, Math.round(radius)),
    span = 2 * r + 1;
  let source = new Float32Array(width * height),
    output = new Float32Array(width * height);
  for (let i = 0; i < source.length; i++) source[i] = data[i * 4 + 3]!;
  // Two separable box passes match the existing pixel-effects fallback, with
  // just two alpha buffers instead of four colour channels per buffer.
  for (let pass = 0; pass < 4; pass++) {
    const horizontal = pass % 2 === 0,
      lines = horizontal ? height : width,
      length = horizontal ? width : height,
      step = horizontal ? 1 : width;
    for (let line = 0; line < lines; line++) {
      const start = horizontal ? line * width : line;
      let sum = 0;
      for (let p = -r; p <= r; p++)
        sum += source[start + Math.max(0, Math.min(length - 1, p)) * step]!;
      for (let p = 0; p < length; p++) {
        output[start + p * step] = sum / span;
        sum +=
          source[start + Math.min(length - 1, p + r + 1) * step]! -
          source[start + Math.max(0, p - r) * step]!;
      }
    }
    [source, output] = [output, source];
  }
  for (let i = 0; i < source.length; i++) {
    data[i * 4] = data[i * 4 + 1] = data[i * 4 + 2] = 255;
    data[i * 4 + 3] = source[i]!;
  }
  return pixels;
}
